<mat-card flex="100">
  <mat-card-title>Maintenance Parameters</mat-card-title>
  <mat-divider></mat-divider>
  <div class="content">
    <div class="search-container">
      <div>
        <fl-aircraft-autocomplete-v2
          gdArea="aircraft"
          placeholder="Select Aircraft"
          [formControl]="selectedAircraftIdCtrl"
        ></fl-aircraft-autocomplete-v2>
      </div>
      <div *ngIf="!selectedAircraftIdCtrl.value">
        <p>Please select an aircraft to view its maintenance parameters</p>
      </div>
    </div>
    <div *ngIf="aircraft$ | async; let aircraft" class="aircraft-container">
      <div class="aircraft-parameters">
        <div *ngIf="!aircraft.configurationClassId; else compare" class="no-configuration">
          <p>Maintenace parameters unavailable (no configuration class).</p>
        </div>
        <ng-template #compare>
          <div *ngIf="values$ | async; else loading; let values" class="snapshot-form">
            <fl-maintenance-comparison-form [values]="values" (save)="createSnapshot($event)">
            </fl-maintenance-comparison-form>
          </div>
        </ng-template>
      </div>
      <div class="aircraft-snapshots">
        <h3>Current Snapshots</h3>
        <ng-container *ngIf="snapshots$ | async; let snapshots; else: loadingMsg">
          <ng-container *ngIf="snapshots.length === 0"> No snapshots. </ng-container>
          <ng-container *ngIf="snapshots.length > 0">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let snapshot of snapshots">
                  <td>{{ snapshot.snapshotEffectiveDate }}</td>
                  <td>{{ snapshot.remarks }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </ng-container>
        <ng-template #loadingMsg> Loading... </ng-template>
      </div>
    </div>
  </div>
  <ng-template #loading>
    <fl-loading-container [loading]="true"> </fl-loading-container>
  </ng-template>
</mat-card>
